import React from 'react';
import {SVGButton, Flex, MarkdownDisplay, RemoveItemModal, Jibber} from '/app/src/component'
import style  from './style.css'
import {ellipsis} from '/app/src/lib'
import {sortableHandle} from 'react-sortable-hoc'


class Item extends Jibber{
    constructor(props){
        super(props)
        this.useState({
            settingClick: false,
            confirmRemoval: false,
            hover: false,
        })
        this._renderSettingsButton = this._renderSettingsButton.bind(this)
        this._renderConfirmRemoval = this._renderConfirmRemoval.bind(this)
    }
    _renderConfirmRemoval(){
        return (
            <RemoveItemModal
                title='Ta bort meddelande'
                open={this.state.confirmRemoval}
                onClose={()=>{this.setConfirmRemoval(false)}}
                onRemoveClick={()=>{this.props.onDeleteClick()}}
                text={<Flex w='100%' center><div>Är du säker på att du vill ta bort &nbsp; <strong> {this.props.item.message.message.title}</strong></div></Flex>}

            />
        )
    }

    render(){
        const isSelected = this.props.item.id === this.props.selected
        const DragHandle = sortableHandle(() =>
            <SVGButton
                src='/images/ChangeOrder_M.svg'
                color='darkgrey'
            />
        );
        const AutoWrapperProps = {
            onMouseEnter : () => this.setState({hover: true}),
            onMouseLeave : () => this.setState({hover: false}),
            className: style.Item,
            grow: true,
            vAlignContent: 'center',
            onClick: this.props.onClick,
            border: isSelected?'2px solid #4ec1e0': '2px solid white',
            backgroundColor: isSelected?'lightblue': 'darkwhite',
            overflow: 'hidden',
        }

        return (
            <Flex {...AutoWrapperProps}>
                {this.state.confirmRemoval && this._renderConfirmRemoval()}

                <Flex className={style.Message} grow
                    hAlignContent='left' vAlignContent='center'
                    overflow='hidden'
                    paddingLeft='20px'
                >
                    <MarkdownDisplay  height='80px' text={this.props.item.message.message.message}/>
                </Flex>

                <Flex className={style.Title} center basis='20%'>
                    {this.props.item.message.message.title}
                </Flex>
                <Flex
                    center
                    basis='20%' marginRight='35px'
                    className={style.Title}
                >
                    {ellipsis(this.props.item.message.url,10)}
                </Flex>

                <Flex className={style.Prio} basis='10%'
                    hAlignContent='center' vAlignContent='center'
                >
                    {parseInt(this.props.item.message.message.priority, 10)+1}
                </Flex>

                <Flex basis='90px' h='100%' borderRadius='60px'>

                {this.props.changePrio === false && (this.state.hover || isSelected)
                    && this._renderSettingsButton()
                }
                {
                    this.props.changePrio === true &&
                        <DragHandle/>
                }
                </Flex>
            </Flex>
        )
    }

    _renderSettingsButton(){
        return (
            <Flex
            center  height='100%' grow marginRight='35px'>
                <SVGButton
                    title='Radera'
                    src='/images/Trash.svg'
                    color='darkgrey'
                    hover='red'
                    onClick={() => this.setState({confirmRemoval: true})}
                />

                <SVGButton
                    title='Redigera'
                    src='/images/Edit_M.svg'
                    onClick={this.props.onEditClick}
                    color='darkgrey'
                    hover='blue'
                />
            </Flex>
        )
    }
}



export default Item;



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/AutoMessage/ListScreen/Item.js